import { useQuery } from '@tanstack/react-query';

import getPromoBrief from 'Api/productivity-host/getPromoBrief';

import getPromoBriefResponse from './model/response/getPromoBriefResponse';

const useGetPromoBrief = () => {
  return useQuery({
    queryKey: ['promo-brief'],
    queryFn: async () => {
      const response = await getPromoBrief();

      return getPromoBriefResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetPromoBrief;
